import moment from "moment-timezone";

/*
 * Which blocks can be dragged.
 *
 * react-calendar-timeline only lets a selected item be dragged: pressing on
 * an unselected one pans the grid. With a mouse or trackpad the movable
 * bookings around the view are handed to it as selected, so press-and-drag
 * moves one. On a touch screen only the booking tapped is, so a swipe across
 * the grid still scrolls it.
 *
 * Only those around the view, and the same array while they don't change:
 * the timeline re-renders every block whenever `selected` is a new array, and
 * checks each block against the whole list. Handing it every loaded booking,
 * new on every render, froze the browser on a busy matrix.
 */
export const draggableIds = (items, chosenItemId, dragOnPress, window) => {
  if (dragOnPress) {
    return items
      .filter(
        (i) =>
          i.canMove &&
          (!window ||
            (moment(i.end_time).valueOf() > window.start &&
              moment(i.start_time).valueOf() < window.end)),
      )
      .map((i) => i.id);
  }
  const chosen = items.find((i) => i.id === chosenItemId);
  return chosen?.canMove ? [chosen.id] : [];
};

// The window of time whose bookings can be pressed and dragged: the view and
// one view's width either side, about what the timeline itself draws.
export const dragWindowAround = (start, end) => {
  const span = end - start;
  return { start: start - span, end: end + span };
};

// Whether the window needs moving to keep up with the view: scrolled or
// zoomed out past it, or zoomed in so far it would hold far more than needed.
export const dragWindowStale = (window, start, end) =>
  !window ||
  start < window.start ||
  end > window.end ||
  window.end - window.start > 6 * (end - start);

// The previous list when it holds the same ids, so the timeline sees no change.
export const keepIfSame = (previous, next) =>
  previous &&
  previous.length === next.length &&
  previous.every((id, i) => id === next[i])
    ? previous
    : next;
